import { ProductType } from '@onbeefapp/constants';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { OrderDetailsContext } from '../../contexts/OrderDetailsContext';
import { TrackingContext } from '../../contexts/TrackingContext';
import { useSlug } from '../../hooks/useSlug';
import { useMerchantCache } from '../../queries/home';
import { ProductCartType, useCartStore } from '../../stores/cart';
import CardHorizontalProduct from '../Cards/CardHorizontalProduct';
import { CardRewardProduct, CardPointReward } from '../Cards/CardRewardProduct';
import Skeleton from '../Skeleton/Skeleton';
import { LoyaltyPointsRewardCartCTA } from '../../pages/LoyaltyClub/LoyatyPointsCTA';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';

const ListCartProduct: React.FC = () => {
  const params = useSlug();

  const { data, isLoading } = useMerchantCache(params.slug);

  const { products, isExtension, selectedPointReward } = useCartStore(
    (state) => ({
      products: state.products,
      isExtension: state.isExtension,
      selectedPointReward: state.selectedPointReward,
    }),
  );

  const { rewardProduct, giftProduct } = React.useContext(OrderDetailsContext);

  const dataTotal = data?.content.merchant.config;

  const navigate = useNavigate();

  const { track } = React.useContext(TrackingContext);

  if (Object.values(products).length <= 0)
    return (
      <div className="flex flex-col items-start justify-start w-full mt-4">
        <button
          className="text-sm font-bold self-center text-center text-primary"
          onClick={() => {
            track(`OnCustomerLeaveCart`, {});
            navigate(`/`);
          }}
        >
          Clique aqui para adicionar itens na sua sacola
        </button>
      </div>
    );

  const calculateGramsPerPerson = (products: ProductCartType[]) => {
    let kitServings = 0;
    let totalWeight = 0;
    let weightPerServing = 300;

    products.forEach((product) => {
      if (product.product_type === ProductType.KG) {
        totalWeight += product?.totalAmount ?? 0;
        weightPerServing = dataTotal?.weight_per_serving ?? 300;
      } else if (
        product.product_type === ProductType.KIT &&
        product.number_of_people
      ) {
        kitServings += product.number_of_people * product.quantity;
      }
    });
    const servings = Math.floor(totalWeight / weightPerServing) + kitServings;
    return servings;
  };

  return (
    <div
      style={
        isExtension
          ? { marginBottom: '20rem' }
          : {
              marginBottom: '8.5rem',
            }
      }
      className="flex flex-col items-start justify-start px-2 gap-2"
    >
      <LoyaltyPointsRewardCartCTA />

      <div className="flex flex-col w-full mt-3">
        <div className="flex flex-row justify-between w-full">
          <Skeleton isLoading={isLoading} className="h-6 rounded-lg w-full">
            <ShoppingBagIcon className="w-5 h-5" />
            <div className="flex flex-row justify-between w-full">
              <div className="ml-2 mr-3 font-bold text-sm">Produtos</div>
              {dataTotal?.weight_per_serving !== 0 &&
              dataTotal?.weight_per_serving !== null
                ? calculateGramsPerPerson(Object.values(products)) > 0 && (
                    <div className="flex flex-row gap-2 px-4 items-center font-medium -mt-1 p-1 text-center text-sm border border-gray-900 rounded-full border-spacing-2">
                      <span>Carnes servem +/- </span>
                      <b>{calculateGramsPerPerson(Object.values(products))}</b>
                    </div>
                  )
                : null}
            </div>
          </Skeleton>
        </div>
        <div className="flex flex-col items-start justify-start w-full mt-4 gap-2">
          {selectedPointReward && (
            <CardPointReward reward={selectedPointReward} />
          )}

          {Object.values(products).map((product: ProductCartType) => (
            <CardHorizontalProduct
              key={`ProductCart${product.id}`}
              product={product}
            />
          ))}
          {!isExtension && rewardProduct && (
            <CardRewardProduct product={rewardProduct} />
          )}
          {!isExtension && giftProduct && (
            <CardRewardProduct product={giftProduct} />
          )}
        </div>
        {!isExtension && (
          <div
            className={`flex flex-col items-start justify-start w-full h-auto mt-4 mb-8`}
          >
            <Skeleton
              isLoading={isLoading}
              className="self-center h-4 rounded-lg w-80"
            >
              <button
                className="text-sm font-bold self-center text-center text-primary hover:underline cursor-pointer"
                onClick={() => {
                  track(`OnCustomerLeaveCart`, {});
                  navigate(`/`);
                }}
              >
                Clique aqui para adicionar itens na sua sacola
              </button>
            </Skeleton>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListCartProduct;
